module.exports = __webpack_public_path__ + "media/music/piano_7-f0d01eb6.mp3";